// Espelha src/config/protectedAccounts.js do caio-tabet-backend — só pra decidir o que
// mostrar/habilitar na UI. A trava de verdade é sempre no backend (requireUserDeletePermission).
export const SUPREME_ADMIN_EMAIL = 'gestaonovaeradigital@gmail.com'
export const PROTECTED_USER_EMAIL = 'alexandresaintss@gmail.com'

export const canDeleteUsers = (email) => email === SUPREME_ADMIN_EMAIL || email === PROTECTED_USER_EMAIL
